<template>
  <div id="tab-container" class="container-fluid">
    <div v-if="$store.state.sheet_type == SheetTypeEnum.LessonKyouzai" class="row pl-2 tab-main-area">
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 1}" @click="toFieldEdit()">
        <h6>1.配点Excelの登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 2}" @click="toCorrectImageUpload()">
        <h6>2.解答用紙の登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 3}" @click="toPositionEdit()">
        <h6>3.採点枠の設定</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 7}" @click="toExplanationImageUpload()">
        <h6>4.解答解説の登録</h6>
      </div>
    </div>
    <div v-else-if="$store.state.sheet_type == SheetTypeEnum.ApprovalExam" class="row pl-2 tab-main-area">
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 1}" @click="toFieldEdit()">
        <h6>1.配点Excelの登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 2}" @click="toCorrectImageUpload()">
        <h6>2.模範解答の登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 3}" @click="toPositionEdit()">
        <h6>3.採点枠の設定</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 4}" @click="toScorePositionEdit()">
        <h6>4.得点枠の設定</h6>
      </div>
    </div>
    <div v-else class="row pl-2 tab-main-area">
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 1}" @click="toFieldEdit()">
        <h6>1.配点Excelの登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 2}" @click="toCorrectImageUpload()">
        <h6>2.模範解答の登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 3}" @click="toPositionEdit()">
        <h6>3.採点枠の設定</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 4}" @click="toScorePositionEdit()">
        <h6>4.得点枠の設定</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 5}" @click="toAnswerImageUpload()">
        <h6>5.解答用紙の登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 6}" @click="toQuestionImageUpload()">
        <h6>6.問題用紙の登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 7}" @click="toAutoReviewTemplateEdit()">
        <h6>7.講評文の登録</h6>
      </div>
      <div v-if="$store.getters.isOptionMovieActive" class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 8}" @click="toMovieContentUpload()">
        <h6>8.動画の登録</h6>
      </div>
    </div>
  </div>  
</template>

<script>
import Vue from 'vue'
import * as Common from "../commons/common"

export default Vue.extend({
  props: ["tabNo"],
  data() {
    return {
      SheetTypeEnum: Common.SheetTypeEnum,
    }
  },
  methods: {
    toFieldEdit(){
      this.$router.push(`/teacher_site/field_edit/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toCorrectImageUpload(){
      this.$router.push(`/teacher_site/correct_image_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toPositionEdit(){
      this.$router.push(`/teacher_site/position_edit/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toPositionEdit(){
      this.$router.push(`/teacher_site/position_edit/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toScorePositionEdit(){
      this.$router.push(`/teacher_site/score_position_edit/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toAnswerImageUpload(){
      this.$router.push(`/teacher_site/answer_image_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toQuestionImageUpload(){
      this.$router.push(`/teacher_site/question_image_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toExplanationImageUpload(){
      this.$router.push(`/teacher_site/explanation_image_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toAutoReviewTemplateEdit(){
      this.$router.push(`/teacher_site/auto_review_template_edit/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toMovieContentUpload(){
      this.$router.push(`/teacher_site/movie_content_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
  }
})
</script>

<style lang="scss" scoped>
  .tab-main-area {
    padding-left: 0px !important;
  }
  .header-tab-button {
    width: 150px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
  }
</style>
